module.exports = __webpack_public_path__ + "static/media/icon-or.00593649.svg";